<template>
    <div>
        <div class="vld-parent" v-if="isLoading">
            <loading
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="true"
                loader="dots"
            ></loading>
        </div>
        <CRow>
            <CCol>
                <CCol sm="10">
                    <CRow class="displayFlex">
                        <h4>Employee Details</h4>
                        <span class="EditButton">Edit</span>
                    </CRow>
                </CCol>
                <CCol>
                    <CDataTable
                        :items="employeeDetails"
                        :fields="items"
                        :column-filter="false"
                        hover
                        pagination
                        addTableClasses="table table-borderless table-hover table-sm table-condensed table-class"
                        style="width: 85%"
                        class="mt-1"
                    >
                    </CDataTable>
                </CCol>
                <CCol>
                    <CButton color="info" @click="addNewEmployee">
                        Add Employees
                    </CButton>
                </CCol>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import * as database from '../../services/database-connectivity';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
const items = [
    { key: 'No' },
    { key: 'Name' },
    { key: 'Address' },
    { key: 'token', label: 'Preferred token' },
    { key: 'Frequency' },
    { key: 'Rate', label: 'Rate in USD/BTC/ETH/USDT/USDC' }
];
export default {
    created: async function() {
        // await swap.initSwap();
        this.isLoading = true;
        var employees = await database.getAllEmployees();
        for (let i = 0; i < employees.length; i++) {
            this.employeeDetails.push({
                No: i + 1,
                Name: employees[i].name,
                Address: employees[i].wallet_address,
                token: employees[i].preferred_currency,
                Frequency: employees[i].payment_frequency,
                Rate: employees[i].amount + ' ETH'
            });
        }
        this.isLoading = false;
    },
    components: {
        Loading
    },
    data() {
        return {
            employeeDetails: [],
            isLoading: false,
            items
        };
    },
    methods: {
        addNewEmployee() {
            this.$router.push('/addEmployees');
        }
    }
};
</script>

<style scoped>
.displayFlex {
    display: flex;
    justify-content: space-between;
    padding-left: 15px;
}
.EditButton {
    font-size: 20px;
    color: #5a99e8;
    align-content: center;
    cursor: pointer;
}
</style>
